import { useCallback, useEffect, useState } from 'react'
import {
  RegisteredEventName,
  broadcastToParent
} from '@finanzcheck/catalyst-pollard'
import { COOKIE_KEY_FCID, getCookie } from 'utils/cookie'
import { getOptimizelyTrackingAttribute } from 'utils/tracking'
import { AgeGroup } from 'constants/components'
import { Data } from 'interfaces/ApolloResponse.interface'

type UseFFGSkipDacButtonParams = {
  isInRceRoute: boolean
  isMiddleAgeGroup: boolean
  ageGroup: AgeGroup
  isDacPage: boolean
  isLastPage: boolean
  data: Data
  onNext: () => void
}

type UseFFGSkipDacButtonResult = {
  isSkipDacButtonVisible: boolean
  skipButtonText: string
  onSkipDacButtonClick: () => void
}

/** Owns the FFG skip-DAC button's visibility, label, and click tracking/navigation. */
export const useFFGSkipDacButton = ({
  isInRceRoute,
  isMiddleAgeGroup,
  ageGroup,
  isDacPage,
  isLastPage,
  data,
  onNext
}: UseFFGSkipDacButtonParams): UseFFGSkipDacButtonResult => {
  const [skipButtonText, setSkipButtonText] = useState('')

  const isSkipDacButtonVisible =
    isDacPage &&
    ((ageGroup === AgeGroup.MIDDLE_AGE_GROUP && isLastPage) || isInRceRoute)

  useEffect(() => {
    setSkipButtonText(
      isInRceRoute || isMiddleAgeGroup
        ? 'Ich habe keinen Online-Banking-Zugang'
        : 'Kontoauszüge manuell hochladen'
    )
  }, [isInRceRoute, isMiddleAgeGroup])

  const onSkipDacButtonClick = useCallback(() => {
    if (ageGroup === AgeGroup.MIDDLE_AGE_GROUP && isDacPage) {
      broadcastToParent({
        eventName: RegisteredEventName.tracking,
        data: {
          event: 'skip_dac_button_click_on_dac_page',
          context: {
            Optimizely: { userId: getCookie(COOKIE_KEY_FCID) },
            ...getOptimizelyTrackingAttribute(data)
          }
        }
      })
    }
    onNext()
  }, [ageGroup, isDacPage, data, onNext])

  return { isSkipDacButtonVisible, skipButtonText, onSkipDacButtonClick }
}
